class Location {
  store;
  parentLocation;
  id;
  name;
  shortName;
  type;
  timings;
  plan;
  accountId;
  markerSize;

  constructor(parentLocation, store, id, name, shortName, type, timings, plan, markerSize, accountId) {
    this.store = store;
    this.parentLocation = parentLocation;
    this.id = id;
    this.name = name;
    this.shortName = shortName;

    this.type = type;
    this.timings = timings;
    this.plan = plan;
    this.markerSize = markerSize;
    this.accountId = accountId;
  }

  static fromJSON(store, json) {
    let {parentLocation, id, name, shortName, type, timings, image: plan, furnitureSizedTo:markerSize, accountId} = json;
    return new Location(parentLocation, store, id, name, shortName, type, timings, plan, markerSize, accountId);
  }
}

export default Location;
